import Axios from 'axios';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { emailRegex, eINRegex, formatPhoneNumber, logout, getPractice } from '../common';
import ErrorMessages from '../../errorConfig';
import PmsUrlConfig from '../../urlConfig';
import BasicPracticeSettings from './BasicPracticeSettings';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import { setAuthToken } from '../common';

export default function UpdateBasicSettings() {
    const practiceDetails = useSelector(state => state.practiceDetails);
    const dispatch = useDispatch();
    if (!practiceDetails)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;
    if (!practice)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />
    var practiceId = practice._id;

    const loginDetails = useSelector(state => state.loginDetails);
    var token = "";
    if (loginDetails) {

        token = loginDetails.jwtToken;
    }

    const BasicDetailsSchema = Yup.object().shape({
        entityName: Yup.string()
            .required(ErrorMessages.ENTITY_NAME_REQUIRED)
            .min(2, ErrorMessages.NAME_TOO_SHORT)
            .max(50, ErrorMessages.NAME_TOO_LONG),

        phoneNo: Yup.string()
            .required(ErrorMessages.PHONE_NUM_REQUIRED),
        entityEmail: Yup.string()
            .required(ErrorMessages.EMAIL_REQUIRED)
            .matches(emailRegex, ErrorMessages.EMAIL_INVALID),
        entityEin: Yup.string()
            .required(ErrorMessages.EIN_REQUIRED)
            .matches(eINRegex, ErrorMessages.EIN_INVALID),
    })
    var formattedPhoneNum = formatPhoneNumber(practice.phoneNum);
    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;
    return (
        <div>
            <Formik
                initialValues={{
                    phoneNo: formattedPhoneNum,
                    entityName: practice.practice_name,
                    entityEin: practice.EIN,
                    entityEmail: practice.practice_email,
                    npi: practice.NPI,
                    website: practice.website,

                }}
                validationSchema={BasicDetailsSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setAuthToken(token);
                    Axios.post(PmsUrlConfig.BOS_EDIT_PRACTICE_URL,
                        {
                            _id: practiceId,
                            practice_name: values.entityName,
                            EIN: values.entityEin,
                            practice_email: values.entityEmail,
                            phoneNum: values.phoneNo.replace(/[^\d]/g, ''),
                            NPI: values.npi,
                            website: values.website,
                            billing_address: {
                                street1: practice.billing_address.street1,
                                street2: practice.billing_address.street2,
                                city: practice.billing_address.city,
                                state: practice.billing_address.state,
                                zip_code: practice.billing_address.zip_code,
                            },
                            mailing_address: {
                                street1: practice.mailing_address.street1,
                                street2: practice.mailing_address.street2,
                                city: practice.mailing_address.city,
                                state: practice.mailing_address.city,
                                zip_code: practice.mailing_address.zip_code,
                            }
                        }
                    ).then((response) => {
                        if (response.status === 200) {
                            getPractice(practiceId, dispatch, token);
                            dispatch({
                                type: 'practiceUpdateSuccess',
                            })
                            setSubmitting(false);
                        }
                        else if (response.status === 400) {
                            console.log("STATUS 400:", response)
                            setSubmitting(false);
                            // dispatch({
                            //     type: 'practiceUpdateError',
                            //     payload: response.data.error_code.description
                            // })
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        console.log("ERROR:", error)
                        setSubmitting(false);
                        // dispatch({
                        //     type: 'practiceUpdateError',
                        //     payload: error.response.data.error_code.description
                        // })
                    })
                }}

            >
                {({ errors, touched, values, handleChange, setFieldValue, handleBlur, isSubmitting }) => (
                    <Form id="update_basic_settings_form">
                        <div className="w-full max-w-4xl">
                            {successMsg && <div className='mb-4 p-3 text-green-800 bg-green-100 rounded border border-green-200'>{successMsg}</div>}
                            {errorMsg && <div className='mb-4 p-3 text-red-800 bg-red-100 rounded border border-red-200'>{errorMsg}</div>}
                            <BasicPracticeSettings
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isEditPage="true"
                            />
                            <div className="mt-6">
                                <button 
                                    type="submit" 
                                    disabled={isSubmitting}
                                    className="px-6 py-2 h-10 bg-gradient-to-r from-[#0B6D76] to-[#09757F] text-white font-semibold rounded-lg shadow-lg hover:from-[#095C64] hover:to-[#0A6B73] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0B6D76] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

